import React, { Component } from 'react';
import '../../App.css';

import Footer from '../reusables/footer'

import logo from '../../img/corpo.jpg'
import fruit from '../../img/fruit.png'
import fish from '../../img/fish.png'
import roses from '../../img/roses.png'

class Empresa extends Component {
  render() {
    return (
      <div className="Empresa">
        <div className="main-container-empresa">
          <div id="logo-empresa">
            <img src={logo} alt=""/>
          </div>
          <div id="info-empresa">
            <h1>О Нас</h1>
            <p>PIORICOST® является частью ЭКСПОРТНЫЕХ ПРОИЗВОДСТВ “LA MANÁ” C. A., корпоративные офисы находятся в Кито. D. M, Эквадор. Экспортные производства “LA MANÁ” C.A. ЭКСПОРТНЫЕ ПРОИЗВОСДТВА занимается раз­ви­тием аг­ро­про­мыш­лен­ной ин­те­гра­ции  и агропромышленным сектором,  деятельности, которые  включают производства и коммерциализацию сельскохозяйственных, лесоводственных и рыбных продуктов, например: питахайя, банан, какао, розы, креветки, креветки, тунец, ракообразные, моллюски и свежие продукты от рыболовства для дальнейшей индустриализации, на крупнейшие  рынки мира, таких как: США, Европейский Союз, Россия, Китай, Саудовская Аравия и другие, с своим брендами PIORICOST FRUIT®, PIORICOST FISH® Y PIORICOST ROSES®.</p>
            <div className="logos-container">
              <img src={fruit} alt=""/>
              <img src={fish} alt=""/>
              <img src={roses} alt=""/>
            </div>
            <h1>Наша миссия</h1>
            <p>В экспортных производств “LA MANÁ” C.A.  Мы сильно привержены продвижению развития торговли аквакультурной и агропромышленной продукции высокого качества, учитывая потребности каждого из наших клиентов и приспосабливаясь к каждому их требований, мы осознаем, что наша цель имеет работать эффективно, чтобы получить наилучшие результаты как с нашими поставщиками, рабочими, партнерством и особенно с нашими клиентами.</p>
            <h1>Видение</h1>
            <p>Стать одним из крупнейших корпорацией с мировым присутствием посредством наши филиалы по всему миру. ЭКСПОРТНЫЕ ПРОИЗВОДСТВА “LA MANÁ” C. A., имеет цель поддержать развитие Эквадора, и сделав так что наша страна преобразовалась иконом инноваций и научного развитияб мы к этому стремимся под рукой научных исследований (растительной биотехнологии) и ее последовательная приверженность инновациям, чтобы стать мировым лидером в производстве и маркетинге сельскохозяйственной продукции, аквакультуры и агропромышленности.</p>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Empresa;


// WEBPACK FOOTER //
// ./src/components/ru-empresa/index.js